<template>
  <div class="index-card__summary">
    <z-link
      v-for="(item, index) in limitedSummary"
      :key="item.id"
      tag="button"
      class="index-card__summary__link"
      @click="onSummaryClick(item.id)"
    >
      {{ index + 1 }}) {{ item.text }}
    </z-link>
    <z-button
      v-if="summary.length > 10 && !isExpanded"
      tag="button"
      variant="tertiary"
      class="index-card__expand-button"
      @click="onExpandClick"
    >
      Ver mais
      <z-icon
        size="medium"
        :icon="['fas', 'chevron-down']"
      />
    </z-button>
  </div>
</template>
<script>
import { promiseDelay } from '~/assets/js/utils/delay'

export default {
  name: 'IndexSummary',
  props: {
    summary: {
      type: Array,
      required: true,
    },
    setBottomSheetOpen: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      isExpanded: false,
    }
  },
  computed: {
    limitedSummary () {
      return this.isExpanded ? this.summary : this.summary.slice(0, 10)
    },
  },
  methods: {
    async onSummaryClick (id) {
      this.setBottomSheetOpen(false)

      await promiseDelay(1)

      document.getElementById(id).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      })
    },
    onExpandClick () {
      this.isExpanded = true
    },
  },
}
</script>

<style lang="scss" scoped>
.index-card__summary {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: var(--unit-0400);
}

.index-card__summary__link {
  text-align: left;
}

.index-card__expand-button {
  justify-content: start;
  min-height: 0;
  padding: 0;
}
</style>
